import type { SvgIconProps } from './types';

export function ReferralNetworkIcon(props: SvgIconProps) {
  return (
    <svg className="referral-network-icon" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
            <circle cx="60" cy="60" r="54" className="referral-network-bg" />
            <path d="M42 56 L60 44 L78 56" className="referral-network-line" strokeWidth="2.5" strokeLinecap="round" />
            <path d="M36 68 C48 58 52 58 60 68" className="referral-network-line" strokeWidth="2.5" strokeLinecap="round" />
            <path d="M84 68 C72 58 68 58 60 68" className="referral-network-line" strokeWidth="2.5" strokeLinecap="round" />
            <g className="referral-network-person referral-network-person-side">
                <circle cx="32" cy="50" r="9" className="referral-network-head" />
                <path d="M18 86 C18 72 26 66 32 66 C38 66 46 72 46 86" className="referral-network-body" />
            </g>
            <g className="referral-network-person referral-network-person-center">
                <circle cx="60" cy="36" r="11" className="referral-network-head" />
                <path d="M40 88 C40 70 50 62 60 62 C70 62 80 70 80 88" className="referral-network-body" />
            </g>
            <g className="referral-network-person referral-network-person-side">
                <circle cx="88" cy="50" r="9" className="referral-network-head" />
                <path d="M74 86 C74 72 82 66 88 66 C94 66 102 72 102 86" className="referral-network-body" />
            </g>
        </svg>
  );
}
